import { API_METHODS, API_URL, MAX_API_TIMEOUT } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
export const getGenerateReport = async (payload: any = {}) => {
  const filterUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.GENERATE_REPORT}`;
  const config: any = {
    method: API_METHODS.POST,
    url: filterUrl,
    data: payload,
    timeout: MAX_API_TIMEOUT,
  };
  const res = await kf1AuthenticatedHttpClient(config);
  return res.data;
};
